import { Tooltip } from "antd";
import React, { useRef } from "react";
import { useState } from "react";
import useDebounce from "../../hooks/useDebounce";
import { CheckBoxInput } from "../common/Buttons";
import { IconSetting } from "../Layout/Icons";
import { AnimatePresence, motion } from "framer-motion";
import useOutsideAlerter from "../../hooks/useOutsideAlerter";

export default function ButtonSettings({
  columns = [],
  showColumns,
  setShowColumns,
  columns_type = 'prisync_columns'
}) {
  const wrapperRef = useRef(null);

  const [internalColumns, setInternalColumns] = useState(showColumns);
  useDebounce(
    () => {
      setShowColumns(() => {
        localStorage.setItem(
          columns_type,
          JSON.stringify(internalColumns)
        );

        return internalColumns;
      });
    },
    1000,
    [internalColumns.length]
  );
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);

  const handlerActive = () => {
    setOpen((prev) => {
      if (!prev) setInternalColumns(showColumns);
      return !prev;
    });
  };

  return (
    <div className="position-relative" ref={wrapperRef}>
      <Tooltip placement="top" title="View columns">
        <div
          className="rounded-circle p-1 d-flex align-items-center justify-content-center"
          style={{
            background: open ? "#D9D9D9" : "rgba(217, 217, 217, 0.4)",
            width: 28,
            height: 28,
          }}
          onClick={() => {
            handlerActive();
          }}
        >
          <IconSetting color={open ? "#838383" : "rgba(131, 131, 131, 0.4)"} />
        </div>
      </Tooltip>
      <AnimatePresence>
        {open && (
          <ActiveShow
            wrapperRef={wrapperRef}
            internalColumns={internalColumns}
            setInternalColumns={setInternalColumns}
            columns={columns}
            onClose={() => handlerActive()}
          />
        )}
      </AnimatePresence>
    </div>
  );
}

const ActiveShow = ({
  internalColumns,
  setInternalColumns,
  columns,
  onClose,
  wrapperRef,
}) => {
  const onAction = () => {
    onClose();
  };
  useOutsideAlerter(wrapperRef, onAction);
  return (
    <motion.div
      initial={{ opacity: 0 }}
      exit={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5, origin: 1 }}
      className="bg-white p-1 position-absolute"
      style={{
        background: "#FFFFFF",
        border: "1px solid #D9D9D9",
        borderRadius: 4,
        right: 0,
        right:
          internalColumns.length > 2 &&
          internalColumns.filter((d) =>
            ["SKU", "Prod. cat.", "Brand", "MPN", "EAN", "Prime cost"].includes(
              d
            )
          ).length >= 2
            ? 0
            : -140,
        top: 35,
        width: 170,
        zIndex: 15,
      }}
    >
      {columns.map((val, idx) => (
        <React.Fragment key={idx}>
          <CheckBoxInput
            checked={internalColumns.includes(val)}
            text={<div className="text-xs font-normal">{val}</div>}
            onChange={() => {
              setInternalColumns((prev) => {
                let data = prev;
                if (prev.includes(val)) data = prev.filter((d) => d !== val);
                else data = [...new Set([...prev, val])];

                return data;
              });
            }}
          />
          {columns.length - 1 !== idx && <div className="mb-1" />}
        </React.Fragment>
      ))}
    </motion.div>
  );
};
